<app-dialog-wrapper [isClosing]="isClosing" (animationend)="onAnimationEnd()">
  <div class="w-full p-2 flex-1">
    <div class="flex justify-end mt-4">
      <button (click)="onCancel()" class="bg-white w-full font-bold text-lg py-4 shadow-md rounded-full">Retour</button>
    </div>

    <div class="m-4">
      <h2 class="mx-auto max-w-2xl m-4 w-full">Historique des paiements</h2>
    </div>

    <div *ngIf="data && (!data.payments || data.payments.length === 0)">
      Aucun paiement enregistré.
    </div>

    <div class="p-4 border rounded-lg shadow-sm bg-white space-y-3">
      <div *ngFor="let payment of data?.payments" class="p-3 rounded-md bg-gray-50 border border-gray-200">
        <p class="text-sm text-gray-600 font-medium">
          {{ this.capitalizeFirstLowerRest(paymentType(payment.type_payment)) }}
          <span class="text-gray-400"> / </span>
          <span class="text-sm text-gray-600 font-medium">
            {{ paymentMeanLabelMap[payment.id_payment_mean] || '...' }}
          </span>
        </p>

        <p class="text-lg text-gray-800 font-bold mt-1">
          {{ payment.total | number: data.decimalString }}
          {{ data.currencySymbol }}

          <span *ngIf="payment.TIPS !== 0" class="text-green-600 font-normal text-sm">
            + {{ payment.TIPS | number: data.decimalString }}
            {{data.currencySymbol}} en pourboire
          </span>
        </p>
      </div>
    </div>
  </div>
</app-dialog-wrapper>